﻿import * as bootstrap from 'bootstrap';




export function showToast(statusCode, message) {
    const toaster = document.getElementById('bookerToaster');
    const toasterIcon = document.querySelector('.d-flex i');
    const toasterBody = toaster.querySelector('.toast-body');
    toaster.className = '';

    const isSuccess = statusCode === 'success';

    toaster.classList.add(isSuccess ? 'text-bg-success' : 'text-bg-danger', 'rounded-3');
    toasterIcon.className = isSuccess
        ? 'bi bi-hand-thumbs-up h4 m-2'
        : 'bi bi-exclamation-triangle h4 m-2';

    toasterBody.textContent = message;

    new bootstrap.Toast(toaster).show();
}